/**
 * Owner: Haselton Baker Risk Group, LLC
 * Date: 4/24/18
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';

import React from 'react';
import { Spinner } from 'reactstrap';
import classNames from 'classnames';
// eslint-disable-next-line import/extensions
import { GoCheck } from 'react-icons/go';
// eslint-disable-next-line import/extensions
import { FaExclamationCircle } from 'react-icons/fa';

import {
  error as errorClass,
  loading as loadingClass,
  success as successClass,
} from './index.module.scss';

type Props = {|
  type: 'success' | 'error' | 'loading',
|};

const success = () => <GoCheck className={classNames('text-success', successClass)} />;

// The same circle-with-"!" as the error alerts and field errors, so an error looks the same
// everywhere.
const error = () => <FaExclamationCircle className={classNames('text-danger', errorClass)} />;

const loading = () => <Spinner className={loadingClass} color="primary" />;

type StatusElement =
  | Element<typeof GoCheck>
  | Element<typeof FaExclamationCircle>
  | Element<typeof Spinner>;

const StatusIcon = ({ type }: Props): StatusElement | Element<'div'> => {
  switch (type) {
    case 'success':
      return success();
    case 'error':
      return error();
    case 'loading':
      return loading();
    default:
  }
  return <div />;
};

export default StatusIcon;
